import { writable } from 'svelte/store';

export const route = writable('intro')
export const resolution = writable()

export const creds = writable({ id: '', date: '' })